import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../app.store';
import { AreasService, ProductCategoriesService, ProductsService } from '@ridango/components';
import { LogService } from '@ridango/core';
import { GotlandActions } from '../../redux/gotland.actions';

@Injectable({
    providedIn: 'root'
})
export class PurchaseProcessService {
    constructor(
        private ngRedux: NgRedux<AppState>,
        private actions: GotlandActions,
        private areasService: AreasService,
        private productCategoriesService: ProductCategoriesService,
        private productsService: ProductsService,
        private ls: LogService
    ) {}
    setPurchaseProgress(step: number) {
        this.ngRedux.dispatch(this.actions.setPurchaseProgress(step));
    }

    resetAreas() {
        this.areasService.setSelectedArea(null);
        this.resetTraveller();
    }
    resetTraveller() {
        this.productCategoriesService.setSelectedTravellerCategory(null);
        this.resetProductCatogory();
    }
    resetProductCatogory() {
        this.productCategoriesService.setSelectedProductCategory(null);
        this.resetProduct();
    }
    resetProduct() {
        this.ls.log(this, 'resetProduct', '');
        this.productsService.setSelectedProduct(null);
    }
}
